import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CvComponent } from './cv/cv.component';
import { PressComponent } from './press/press.component';
import { ContactComponent } from './contact/contact.component';
import { WorksComponent } from './works/works.component';

const routes: Routes = [
  {
    path: 'biographie',
    component: CvComponent,
    data: {
      title: 'Biographie de Cécile Binsztock | Artiste peintre',
      description: 'Découvrez le parcours, les expositions et l’univers de Cécile Binsztock, artiste peintre contemporaine installée dans le Val-d’Oise.',
      pageName: 'Biographie',
      image: '/assets/cecile_portrait.PNG',
      imageAlt: 'Portrait de Cécile Binsztock dans son atelier',
      imageWidth: '549',
      imageHeight: '757',
      lang: 'fr',
    },
  },
  {
    path: 'works',
    component: WorksComponent,
    data: {
      title: 'Œuvres de Cécile Binsztock | Peinture contemporaine',
      description: 'Explorez les œuvres de Cécile Binsztock, peintures contemporaines de gestes, de matières et de couleurs inspirées par le vivant.',
      pageName: 'Œuvres',
      image: '/assets/works/2.jpg',
      imageAlt: 'Œuvre abstraite de Cécile Binsztock',
      imageWidth: '2614',
      imageHeight: '2584',
      lang: 'fr',
    },
  },
  {
    path: 'press',
    component: PressComponent,
    data: {
      title: 'Presse et parutions | Cécile Binsztock',
      description: 'Consultez une sélection d’articles, d’archives et de parutions consacrés au travail de l’artiste peintre Cécile Binsztock.',
      pageName: 'Presse et parutions',
      image: '/assets/press/press_8.jpg',
      imageAlt: 'Article de presse consacré à Cécile Binsztock',
      imageWidth: '842',
      imageHeight: '1191',
      lang: 'fr',
    },
  },
  {
    path: 'contact',
    component: ContactComponent,
    data: {
      title: 'Contact et atelier | Cécile Binsztock',
      description: 'Contactez Cécile Binsztock dans le Val-d’Oise pour une exposition, une collaboration, une commande ou l’acquisition d’une œuvre.',
      pageName: 'Contact',
      image: '/assets/works/2.jpg',
      imageAlt: 'Peinture de Cécile Binsztock',
      imageWidth: '2614',
      imageHeight: '2584',
      lang: 'fr',
    },
  },
  {
    path: 'en/biography',
    component: CvComponent,
    data: {
      title: 'Cécile Binsztock Biography | Contemporary Artist',
      description: 'Discover the career, exhibitions and artistic world of Cécile Binsztock, a contemporary painter based in the Val-d’Oise, France.',
      pageName: 'Biography', image: '/assets/cecile_portrait.PNG', imageAlt: 'Portrait of Cécile Binsztock in her studio', imageWidth: '549', imageHeight: '757', lang: 'en',
    },
  },
  {
    path: 'en/works',
    component: WorksComponent,
    data: {
      title: 'Artworks by Cécile Binsztock | Contemporary Painting',
      description: 'Explore paintings by Cécile Binsztock, contemporary works shaped by gesture, texture, colour and the living world.',
      pageName: 'Artworks', image: '/assets/works/2.jpg', imageAlt: 'Abstract artwork by Cécile Binsztock', imageWidth: '2614', imageHeight: '2584', lang: 'en',
    },
  },
  {
    path: 'en/press',
    component: PressComponent,
    data: {
      title: 'Press and Publications | Cécile Binsztock',
      description: 'Browse a selection of articles, archives and publications devoted to the work of French painter Cécile Binsztock.',
      pageName: 'Press and publications', image: '/assets/press/press_8.jpg', imageAlt: 'Press article about Cécile Binsztock', imageWidth: '842', imageHeight: '1191', lang: 'en',
    },
  },
  {
    path: 'en/contact',
    component: ContactComponent,
    data: {
      title: 'Contact and Studio | Cécile Binsztock',
      description: 'Contact Cécile Binsztock for an exhibition, collaboration, commission or artwork acquisition.',
      pageName: 'Contact', image: '/assets/works/2.jpg', imageAlt: 'Painting by Cécile Binsztock', imageWidth: '2614', imageHeight: '2584', lang: 'en',
    },
  },
  { path: 'en', redirectTo: '/en/works', pathMatch: 'full' },
  { path: '', redirectTo: '/works', pathMatch: 'full' },
  { path: '**', redirectTo: '/works' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
